module.exports = __webpack_public_path__ + "media/audio42.7faacbc8.mp3";